<div class="home-header">
  <h2>Vista de home</h2>
  <app-language-selector></app-language-selector>
</div>
